export const adminMenuConfig = {
  profile: true,
  employees: true,
  projects: false,
  timesheet: false,
  performance: false,
  leaves: false,
  reports: true,
  manageData: true,
};

export const employeeMenuConfig = {
  profile: true,
  projects: false,
  leaves: false,
  timesheet: false,
};

// src/config/dashboardConfig.js
export const dashboardMenuConfig = {
  employeeCount: true,
  projectCount: false,
  pendingLeaves: false,
  pendingTimesheets: false,
  timesheetDefaulters: false,
};

// src/config/employeeDashboardConfig.js
export const employeeDashboardConfig = {
  showProjects: false,
  showHoursWorked: false,
  showLeaveBalance: false,
  showUpcomingHolidays: false,
  showTimesheetButton: false,
  showApplyLeaveButton: false,
};
export const companyInfo = {
  name: "Kairali Resturants",
  address: "Mangaluru, India"
};